import type { RootState } from 'store'
import type { ActionTree } from 'vuex'
import { GET_ALL_DIVISION, GET_ALL_REGION, SCAN_ALL_DIVISION } from './types'
import type { DivisionState } from './types'
import { DivisionService } from '../service/index'
import orderBy from 'lodash/orderBy'

const divisionService = new DivisionService()
export const actions: ActionTree<DivisionState, RootState> = {
  actGetAllDivision({ commit }, params: any) {
    return divisionService
      .getAllDivision(params.company, params.region, params.name)
      .then((result: DivisionModel[]) => {
        const transform = orderBy(result, [(d) => new Date(d.updatedAt)], ['desc'])
        commit(GET_ALL_DIVISION, transform)
        return transform
      })
  },
  actGetAllRegion({ commit, rootState }) {
    const user = rootState.user?.user
    divisionService.getAllRegion(user?.company).then((result: DropDownItem[]) => {
      commit(GET_ALL_REGION, result)
    })
  },
  actCreateDivision(_, params: DivisionModel) {
    return divisionService.createDivision(params)
  },
  actUpdateDivision(_, params: DivisionModel) {
    return divisionService.updateDivision(params)
  },
  actDeleteDivision(_, params: DivisionModel) {
    return divisionService.deleteDivision(params.id, params.company)
  },
  actCheckDivisionUsed(_, params: object) {
    return divisionService.checkDivisionUsed(params.id, params.company)
  },
  actScanAllDivisions({ commit }) {
    return divisionService.scanAllDivisions().then((result: DivisionModel[]) => {
      commit(SCAN_ALL_DIVISION, result)
      return result
    })
  },
  actGetAllDivisionAdmin() {
    return divisionService.getAllUserDivisionAdmin()
  },
  actGetDivision(_, params: object) {
    return divisionService.getDivision(params.divisionId, params.company)
  },
}
